module.exports = __webpack_public_path__ + "portal-static/img/vr.a6090b28.png";